import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaGraduationCap,
  FaBookOpen,
  FaBrain,
  FaSchool,
} from "react-icons/fa";


import img1 from "../assets/kinder1.jpeg";
import img2 from "../assets/primary1.jpeg";
import img3 from "../assets/middle1.jpeg";
import img4 from "../assets/senior1.jpeg";



const features = [

  {
    img: img1,
    title: "Foundational Stage",
    desc: "Fun-based learning for early childhood development.",
    link: "/play-kindergarden",
    icon: <FaBrain />,
    number: "01",
  },

  {
    img: img2,
    title: "Preparatory Stage",
    desc: "Strong foundation with interactive learning methods.",
    link: "/primary-curriculum",
    icon: <FaBookOpen />,
    number: "02",
  },

  {
    img: img3,
    title: "Middle Stage",
    desc: "Balanced academic and co-curricular growth.",
    link: "/middle-curriculum",
    icon: <FaGraduationCap />,
    number: "03",
  },

  {
    img: img4,
    title: "Secondary Stage",
    desc: "Focused academic excellence and discipline.",
    link: "/secondary-school",
    icon: <FaSchool />,
    number: "04",
  },

];



const Features = () => {


return (

<section className="
relative
w-full
bg-[#f7f9fc]
overflow-hidden
py-14
">



<div className="
max-w-[1450px]
mx-auto
px-6
">



{/* HEADER */}

<div className="
text-center
mb-14
">


<motion.p

initial={{
opacity:0,
y:20
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.5
}}

viewport={{
once:true
}}

className="
uppercase
tracking-[5px]
text-[#d4af37]
font-bold
text-xs
md:text-sm
mb-5
"

>

Cambridge International School

</motion.p>




<motion.h2

initial={{
opacity:0,
y:30
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

className="
text-4xl
md:text-6xl
xl:text-7xl
font-black
text-[#07294d]
leading-tight
"

>

Learning Stages


</motion.h2>




<motion.p

initial={{
opacity:0,
y:20
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

className="
max-w-[800px]
mx-auto
text-gray-600
text-base
md:text-lg
leading-8
mt-6
"

>

Empowering students through every stage of learning
with innovation, creativity, discipline, and academic excellence.

</motion.p>


</div>







{/* CARDS */}



<div className="
grid
sm:grid-cols-2
lg:grid-cols-4
gap-6
">



{
features.map((item,index)=>(


<motion.div

key={index}

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.5,
delay:index*0.1
}}

viewport={{
once:true
}}

whileHover={{
y:-8
}}

className="
group
"


>


<Link to={item.link}>


<div className="
bg-white
rounded-[26px]
overflow-hidden
border
border-gray-100
shadow-[0_15px_45px_rgba(0,0,0,0.08)]
hover:shadow-[0_25px_60px_rgba(7,41,77,0.14)]
transition-all
duration-500
relative
">



{/* GOLD LINE */}

<div className="
h-[5px]
bg-[#d4af37]
w-full
">
</div>





{/* IMAGE */}

<div className="
relative
overflow-hidden
">


<img

src={item.img}

alt={item.title}

className="
w-full
h-[210px]
object-cover
transition
duration-700
group-hover:scale-110
"

/>




<div className="
absolute
inset-0
bg-black/20
">
</div>





{/* NUMBER */}

<div className="
absolute
top-3
right-4
text-[65px]
font-black
text-white/30
">


{item.number}


</div>





{/* ICON */}

<div className="
absolute
bottom-4
left-4
w-14
h-14
rounded-2xl
bg-white
flex
items-center
justify-center
text-[#07294d]
text-xl
shadow-xl
group-hover:bg-[#07294d]
group-hover:text-white
transition
">


{item.icon}


</div>



</div>








{/* CONTENT */}


<div className="
p-5
">


<h3 className="
text-xl
font-black
text-[#07294d]
leading-tight
mb-3
">


{item.title}


</h3>



<div className="
w-12
h-[3px]
bg-[#d4af37]
rounded-full
mb-4
">

</div>




<p className="
text-gray-600
text-sm
leading-6
mb-5
">


{item.desc}


</p>






<div className="
flex
items-center
justify-between
">


<span className="
flex
items-center
gap-2
text-sm
font-semibold
text-[#07294d]
group-hover:text-[#d4af37]
transition
">


Explore More

<FaArrowRight className="
group-hover:translate-x-2
transition
"/>


</span>




<div className="
w-9
h-9
rounded-full
border
border-gray-200
flex
items-center
justify-center
text-[#07294d]
group-hover:bg-[#07294d]
group-hover:text-white
transition
">


<FaGraduationCap/>


</div>


</div>



</div>



</div>


</Link>


</motion.div>


))


}


</div>



</div>



</section>

);

};


export default Features;